
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/[slug]/[type]",
      function () {
        return require("private-next-pages/team/[slug]/[type].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/[slug]/[type]"])
      });
    }
  